import ModalElement from "../../../Common/ModalElement"
import { FaRegFileExcel, FaRegFilePdf } from "react-icons/fa";
import { exportToExcel, handleDownload, parseNumber } from "../../../utils";

const InvoiceModal = ({ show, hideModal, extraDetails }) => {
    
    const generateInvoice = (type) => {
        const total = parseNumber(extraDetails?.amount ?? 0)
        if(type == "pdf") {
            extraDetails["total"] = total;
            handleDownload(extraDetails, false);
        } else {
            const vehicleData = extraDetails?.vehicles?.map(item => ({
                company: item?.company ?? "",
                vehicle: item?.vehicle ?? "",
                date: item?.installationdate ?? "",
                amount: item?.amount ?? "",
            }))
            exportToExcel(vehicleData, extraDetails?.invoiceNo, total);
        }
        hideModal();
    }

    return <ModalElement size="md" show={show} title={`Generate Statement`} onHide={hideModal}>
        <div className="text-start">
            <div className="installer-personal mb-3">
                <div className="d-flex justify-content-around align-items-center px-4">
                    <div className="bg-light rounded-circle cursor-pointer" style={{ padding: "40px" }} onClick={() => generateInvoice("pdf")}>
                        <FaRegFilePdf size={60} />
                    </div>
                    <div className="bg-light rounded-circle cursor-pointer" style={{ padding: "40px" }} onClick={() => generateInvoice("excel")}>
                        <FaRegFileExcel size={60} />
                    </div>
                </div>
            </div>
        </div>
    </ModalElement>
}

export default InvoiceModal;